import API_BASE_URL from '../config/api';

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function submitHelp(payload) {
  const res = await fetch(`${API_BASE_URL}/help`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to submit');
  return json.data;
}

export async function listHelp(params = new URLSearchParams()) {
  const url = new URL(`${API_BASE_URL}/help/admin`);
  for (const [k, v] of params.entries()) url.searchParams.set(k, v);
  const res = await fetch(url.toString(), { headers: { ...authHeaders() } });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to load help');
  return json;
}

export async function updateHelpStatus(id, status) {
  const res = await fetch(
    `${API_BASE_URL}/help/admin/${encodeURIComponent(id)}/status`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ status }),
    }
  );
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to update status');
  return json.data;
}
